import React from 'react';
import { howItWorksSteps } from 'pages/Homepage/constants/howItWorks';
import css from './HowItWorks.module.scss';

function HowItWorks () {
  return (
    <section className={css.wrapper}>
      <div className='container'>
        <h2 className={css.title}>How it works</h2>
        <div className={css.description}>
          <div>Personalised online tuition to boost grades and <b>confidence</b></div>
          <div>Improve your <b>grades by 3x</b> with lessons that match your needs and learning goals.</div>
        </div>
        <div className={css.steps}>
          {howItWorksSteps.map(el => (<div key={el.title} className={css.step}>
            <img src={el.icon} alt='' />
            <div className={css.stepTitle}>{el.title}</div>
          </div>))}
        </div>
      </div>
    </section>
  );
}
export default HowItWorks;
